// Collapse near-duplicate sermon_refs rows BEFORE they're inserted.
//
// A single scan can emit more than one ref for the same passage at the same (or
// a nearby) timestamp, which would store — and later show — the same moment on
// the same verse twice. This keeps one ref per (book, chapter, verse, end_verse)
// whenever timestamps fall within WINDOW_S seconds of an already-kept ref; the
// earliest timestamp wins. Exact-same-timestamp dupes are always removed.
//
// Operates on the pre-insert row shape ({ book, chapter, verse, end_verse,
// timestamp_s, ... }). The verse sheet also dedupes this same 10s window at
// display time, so the two layers agree.
export function dedupeRefRows(rows, windowS = 10) {
  if (!Array.isArray(rows) || rows.length < 2) return rows || [];
  const keyOf = (r) => `${r.book ?? ''}|${r.chapter ?? ''}|${r.verse ?? ''}|${r.end_verse ?? ''}`;
  // Earliest-first within each passage so we keep the earliest moment and
  // measure later refs against it.
  const sorted = rows.slice().sort((a, b) => {
    const ak = keyOf(a), bk = keyOf(b);
    if (ak !== bk) return ak < bk ? -1 : 1;
    return (a.timestamp_s ?? 0) - (b.timestamp_s ?? 0);
  });
  const out = [];
  const keptByKey = new Map(); // passage key -> [kept timestamp_s ...]
  for (const r of sorted) {
    const key = keyOf(r);
    const ts = r.timestamp_s ?? 0;
    const kept = keptByKey.get(key) || [];
    if (kept.some((t) => Math.abs(t - ts) <= windowS)) continue;
    kept.push(ts);
    keptByKey.set(key, kept);
    out.push(r);
  }
  return out;
}
